import logger from '@eventbrite/client-logger';
import { AppNamespace } from '../state/app';

export const createMockAppState: (
    overrides?: Partial<AppNamespace>,
) => AppNamespace = (overrides) => ({
    appVersion: 'appVersion',
    ebDomain: 'eventbrite.com',
    event: {
        id: 'eventId',
        organizer_id: 'organizer_id',
    },
    isEventbriteTLD: true,
    locale: 'locale',
    featureFlags: {},
    defaultUserCountry: '',
    locales: [],
    request: {
        correlation_id: 'correlation_id',
        session_id: 'session_id',
        params: {},
    },
    ...overrides,
    useIosProfile: false,
    useAndroidProfile: false,
});

export const genericDynamicImportErrorHandler = (err: any) => {
    logger.error(err);

    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
};
